import Stack from "@mui/material/Stack";
import { useState } from "react";

import { SegmentedToggle } from "~/components/segmented_toggle";
import { Select2ApplyBar } from "~/components/select2";

type InstantFilter = "instant" | "standard";

export interface InstantPopoverProps {
  initialValue?: boolean;
  onApply: (isInstant: boolean) => void;
  onClose: () => void;
}

export function InstantPopover({
  initialValue,
  onApply,
  onClose,
}: InstantPopoverProps) {
  const [value, setValue] = useState<InstantFilter>(
    initialValue === false ? "standard" : "instant",
  );
  const apply = () => {
    onApply(value === "instant");
    onClose();
  };
  return (
    <Stack>
      <Stack sx={{ p: 1 }}>
        <SegmentedToggle
          value={value}
          onChange={setValue}
          options={[
            { value: "instant", label: "Instant" },
            { value: "standard", label: "Standard" },
          ]}
          ariaLabel="Payout speed"
        />
      </Stack>
      <Select2ApplyBar onApply={apply} />
    </Stack>
  );
}
